import { render, staticRenderFns } from "./HorizontalTab.vue?vue&type=template&id=65efe944&scoped=true"
import script from "./HorizontalTab.vue?vue&type=script&lang=js"
export * from "./HorizontalTab.vue?vue&type=script&lang=js"
import style0 from "./HorizontalTab.vue?vue&type=style&index=0&id=65efe944&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65efe944",
  null
  
)

export default component.exports